import {IconCircleCheck, IconCircleX} from '@tabler/icons-react'
import {Flex} from '@mantine/core'

type Props =
  | {
      type: 'number'
      value: number | undefined
    }
  | {
      type: 'boolean'
      value: boolean
    }
  | {
      type: 'interval'
      value: 'never' | 'daily' | 'hourly'
    }

export const FeatureValue = (props: Props) => {
  if (props.type === 'number') {
    return <>{props.value}</>
  }

  if (props.type === 'boolean') {
    return (
      <Flex align={'center'} justify={'center'} c={props.value ? 'green' : 'red'}>
        {props.value ? <IconCircleCheck /> : <IconCircleX />}
      </Flex>
    )
  }

  if (props.type === 'interval') {
    return (
      <Flex align={'center'} justify={'center'}>
        {props.value === 'never' ? '-' : props.value}
      </Flex>
    )
  }

  return null
}
